import { Toaster } from '@doccareplus/ui';
import { useAppDispatch, useAppSelector } from '@doccareplus/kernel/application/store/hooks';
import { removeToast, selectToasts } from '@doccareplus/kernel/application';

/**
 * ToastHost — connects the presentational <Toaster> to the Redux `ui` toast
 * queue. Mounted once at the app root so any `toastApiError`/`showToast` call
 * (from anywhere, including non-React modules) surfaces a snackbar.
 */
export function ToastHost() {
  const toasts = useAppSelector(selectToasts);
  const dispatch = useAppDispatch();

  return <Toaster toasts={toasts} onDismiss={(id) => dispatch(removeToast(id))} />;
}
